<script setup lang="ts">
import { ref } from 'vue'

const isVisible = ref(false)

function handleMouseEnter() {
  isVisible.value = true
}

function handleMouseLeave() {
  isVisible.value = false
}

</script>

<template>
  <span class="wheels-tooltip" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">

    <slot name="trigger"></slot>
    <div class="wheels-tooltip__content" v-if="isVisible">
      <slot name="content"></slot>
    </div>
  </span>
</template>

<style scoped lang="scss">
.wheels-tooltip {
  position: relative;
}

.wheels-tooltip__content {
  position: absolute;
  top: -5px;
  left: 105%;
  z-index: 1000;
  background-color: rgba(var(--cu-gray-900-rgb), .8);
  color: white;
  padding: var(--spacing-2);
  border-radius: var(--spacing-1);
  min-width: 100px;
  text-align: center;
}
</style>
